export enum UserType {
  Director = 'director',
  Parent = 'parent',
}
export type UserTypeKeys = keyof typeof UserType
export type UserTypeValues = `${UserType}`

const reverseMap = new Map<string, UserType>()
Object.values(UserType).forEach((value: UserType) => {
  reverseMap.set(value.toString(), value)
})
export function UserTypeValueOf(str: string) {
  return reverseMap.get(str)
}

export interface IUser {
  schoolhouse: null | {
    id: number
    closedAt: any | null
    migratedToWsCenters: boolean
  }
}

// NOTE (alex): this is based on a very loose definition of a user "type". Use caution when
// deciding to rely on this for new functionality.
export function userType(user: IUser) {
  const { schoolhouse } = user

  return schoolhouse && !schoolhouse.closedAt ? UserType.Director : UserType.Parent
}

export function alreadyMigratedToWsCenters(user: IUser) {
  const { schoolhouse } = user
  return schoolhouse && schoolhouse.migratedToWsCenters
}

export function getUserAndSchoolInfo(): {
  isDirector: boolean
  schoolId: number | null
  migratedToWsCenters: boolean
} {
  const user = window.lego.user as IUser
  if (!user) return { isDirector: false, schoolId: null, migratedToWsCenters: false }

  const isDirector = userType(user) === UserType.Director
  const migratedToWsCenters = (user.schoolhouse && user.schoolhouse.migratedToWsCenters) || false
  const schoolId = user.schoolhouse ? user.schoolhouse.id : null

  return { isDirector, schoolId, migratedToWsCenters }
}
